// back-compat helpers
// TODO: remove this entire module once everyone is using new data-track-*

const legacyDataTrackSelector = '[data-track]';

function migrateOldDataTrack(e) {
  if (!e.dataset || e.dataset.track === undefined) return;

  const [action, section, label, ...value] = e.dataset.track.trim().split('.');

  delete e.dataset.track;

  e.dataset.trackAction = action.replace(/\s*,\s*/, ' ').trim();
  if (section !== undefined) e.dataset.trackSection = section.trim();
  if (label !== undefined) e.dataset.trackLabel = label.trim();
  if (value.length) e.dataset.trackValue = value.join('.').trim();
}

function migrateFutureElementsWithin(element) {
  new global.MutationObserver(mutations =>
    mutations
      .reduce(
        (addedNodes, mutation) =>
          addedNodes.concat(Array.from(mutation.addedNodes)),
        []
      )
      .filter(e => e.nodeType === global.Node.ELEMENT_NODE)
      .reduce(
        (elements, el) =>
          elements.concat(
            el.matches(legacyDataTrackSelector) ? el : [],
            Array.from(el.querySelectorAll(legacyDataTrackSelector))
          ),
        []
      )
      .forEach(migrateOldDataTrack)
  ).observe(element, { childList: true, subtree: true });
}

export default function migrate(scope) {
  [scope]
    .concat(...scope.querySelectorAll(legacyDataTrackSelector))
    .forEach(migrateOldDataTrack);
  migrateFutureElementsWithin(scope);
}
